enum StatusObjecType {
  VEHICLEASSET = "VehicleAsset",
  RESERVATION = "Reservation",
  CONTRACT = "Contract",
  PAYMENT = "Payment",
}

export default StatusObjecType;
